import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';

export const useProblemReports = () => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ['companyProblemReports'],
        queryFn: async () => {
            const res = await api.get('/company/problem-reports');
            if (!res.data || !res.data.success) {
                throw new Error(res.data?.message || 'Failed to fetch problem reports');
            }
            return res.data.data || [];
        },
        staleTime: 1000 * 60 * 5,
    });

    return {
        reports: data || [],
        isLoading,
        error,
        refetch,
    };
};
